module.exports = __webpack_public_path__ + "img/circle_white_expand.c95eedbb.png";